/******** utils.js ********/

function toUSD(num: number): string {
  if (isNaN(num)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(num);
}
function validateEmail(invalue: string): boolean {
  var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  var valid = regex.test(invalue);
  return valid;
}
function isValidCaZipCode(value: string): boolean {
  var re = /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$/;
  return (re.test(value));
}
function isValidUsZipCode(value: string): boolean {
  var re = /^\d{5}([\-]\d{4})?$/;
  return re.test(value);
}
function createCookie(name: string, value: string, days?: number): void {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  } else expires = '';
  document.cookie = `${name}=${value}${expires}; path=/`;
}
function eraseCookie(name: string): void {
  createCookie(name, '', -1);
}
function readCookie(name: string): string {
  var nameEQ = `${name}=`;
  var ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
  }
  return '';
}
function formatCurrency(price: number | string): string {
  price = price.toString().replace(/\$|\,/g, '');
  if (isNaN(Number(price))) price = '0';
  var sign = Number(price) == (price = Math.abs(Number(price)));
  price = Math.floor(price * 100 + 0.50000000001);
  var cents: number | string = price % 100;
  price = Math.floor(price / 100).toString();
  if (cents < 10) cents = `0${cents}`;
  for (var i = 0; i < Math.floor((price.length - (1 + i)) / 3); i++)
    price = `${price.substring(0, price.length - (4 * i + 3))},${price.substring(price.length - (4 * i + 3))}`;
  return `${(sign ? '' : '-')}$${price}.${cents}`;
}
function formatPoints(points: number | string): string {
  points = points.toString().replace(/\$|\,/g, '');
  for (var i = 0; i < Math.floor((points.length - (1 + i)) / 3); i++)
    points = `${points.substring(0, points.length - (4 * i + 3))},${points.substring(points.length - (4 * i + 3))}`;
  return points;
}
function getXMLDataSetTableCount(dsName: string, xmlString: string): number {
  var returnValue = -1;
  var datasetStartIndex = xmlString.toLowerCase().indexOf(`<${dsName.toLowerCase()}>`);
  var datasetEndIndex = xmlString.toLowerCase().indexOf(`</${dsName.toLowerCase()}>`);
  var fieldStartIndex = -1;
  var fieldEndIndex = -1;
  if (datasetStartIndex > -1 && datasetEndIndex > -1) {
    fieldStartIndex = xmlString.toLowerCase().indexOf('<totalTables>'.toLowerCase(), datasetStartIndex);
    if (fieldStartIndex > -1 && fieldStartIndex < datasetEndIndex) {
      fieldStartIndex = `${fieldStartIndex}<totalTables>`.toLowerCase().length;
      fieldEndIndex = xmlString.toLowerCase().indexOf('</totalTables>'.toLowerCase(), fieldStartIndex);
      if (fieldEndIndex > -1 && fieldEndIndex < datasetEndIndex) {
        returnValue = parseInt(
          xmlString.substring(fieldStartIndex, fieldEndIndex)
        );
      }
    }
  }
  return returnValue;
}
function getXMLDataTableRowCount(dsName: string, dtIndex: number, xmlString: string): number {
  var returnValue = -1;
  var datasetStartIndex = xmlString.toLowerCase().indexOf(`<${dsName.toLowerCase()}>`);
  var datasetEndIndex = xmlString.toLowerCase().indexOf(`</${dsName.toLowerCase()}>`);
  var fieldStartIndex = -1;
  var fieldEndIndex = -1;
  if (datasetStartIndex > -1 && datasetEndIndex > -1) {
    //<t0TotalRows>1</t0TotalRows>
    fieldStartIndex = xmlString.toLowerCase().indexOf((`<t${dtIndex}TotalRows>`).toLowerCase(), datasetStartIndex);
    if (fieldStartIndex > -1 && fieldStartIndex < datasetEndIndex) {
      fieldStartIndex = fieldStartIndex + (`<t${dtIndex}TotalRows>`).toLowerCase().length;
      fieldEndIndex = xmlString.toLowerCase().indexOf((`</t${dtIndex}TotalRows>`).toLowerCase(), fieldStartIndex);
      if (fieldEndIndex > -1 && fieldEndIndex < datasetEndIndex) {
        returnValue = parseInt(
          xmlString.substring(fieldStartIndex, fieldEndIndex)
        );
      }
    }
  }
  return returnValue;
}
function getXMLDataFieldValue(dsName: string, dtIndex: number, rowIndex: number, fieldName: string, xmlString: string): string {
  var returnValue = '';
  var datasetStartIndex = xmlString.toLowerCase().indexOf(`<${dsName.toLowerCase()}>`);
  var datasetEndIndex = xmlString.toLowerCase().indexOf(`</${dsName.toLowerCase()}>`);
  var fieldStartIndex = -1;
  var fieldEndIndex = -1;
  if (datasetStartIndex > -1 && datasetEndIndex > -1) {
    fieldStartIndex = xmlString
      .toLowerCase().indexOf((`<t${dtIndex}r${rowIndex}${fieldName}>`).toLowerCase(), datasetStartIndex);
    if (fieldStartIndex > -1 && fieldStartIndex < datasetEndIndex) {
      fieldStartIndex = fieldStartIndex + (`<t${dtIndex}r${rowIndex}${fieldName}>`).toLowerCase().length;
      fieldEndIndex = xmlString.toLowerCase().indexOf((`</t${dtIndex}r${rowIndex}${fieldName}>`).toLowerCase(), fieldStartIndex);
      if (fieldEndIndex > -1 && fieldEndIndex < datasetEndIndex) {
        returnValue = xmlString.substring(fieldStartIndex, fieldEndIndex);
      }
    }
  }
  return returnValue;
}
function getXMLTagValue(tagName: string, xmlString: string): string {
  let tagValue = '';
  const tagStartIndex = xmlString.toLowerCase().indexOf(`<${tagName.toLowerCase()}>`);
  const tagEndIndex = xmlString.toLowerCase().indexOf(`</${tagName.toLowerCase()}>`);
  if (tagStartIndex > -1 && tagStartIndex < tagEndIndex) {
    tagValue = xmlString.substring(tagStartIndex + tagName.length + 2, tagEndIndex);
  }
  return tagValue;
}
function removeBadNumbers(inNumber: string): string {
  var tmpNumber = '';
  for (var i = 0; i < inNumber.length; i++) {
    var tmpStr = inNumber.substring(i, i + 1);
    if (tmpStr === '-' || tmpStr === ' ' || isNaN(Number(tmpStr))) {
    } else {
      tmpNumber = tmpNumber + inNumber.substring(i, i + 1);
    }
  }
  return tmpNumber;
}
function setCookie(c_name: string, value: string, exdays?: number): void {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value = `${encodeURIComponent(value)} ${(exdays === null ? '' : `; expires=${exdate.toUTCString()}`)};path = /`;
  document.cookie = `${c_name}=${c_value}`;
}
function getCookie(c_name: string): string | null {
  var c_value = document.cookie;
  var c_start = c_value.indexOf(` ${c_name}=`);
  if (c_start === -1) {
    c_start = c_value.indexOf(`${c_name}=`);
  }
  if (c_start === -1) {
    c_value = null;
  } else {
    c_start = c_value.indexOf('=', c_start) + 1;
    var c_end = c_value.indexOf(';', c_start);
    if (c_end === -1) {
      c_end = c_value.length;
    }
    c_value = decodeURIComponent(c_value.substring(c_start, c_end));
  }
  return c_value;
}
function showHideLoader(action: string, productIndex: number): void {
  var loader = document.getElementById(`loader${productIndex}`);
  var atc = document.getElementById(`ATC${productIndex}`);
  if (action === 'show') {
    try {
      loader.style.display = '';
      loader.style.visibility = 'visible';
      atc.style.display = 'none';
      atc.style.visibility = 'hidden';
    } catch (e) { }
  } else if (action === 'hide') {
    try {
      loader.style.display = 'none';
      loader.style.visibility = 'hidden';
      atc.style.display = '';
      atc.style.visibility = 'visible';
    } catch (e) { }
  }
}
function showElement(sel: string, elementIndex: number = 0, display: string = "block"): void {
  sel = sel.replace('#', '');
  let element: any = document.getElementById(sel);
  if (element) {
    if (element.length === undefined || element.nodeName === 'SELECT') {
      element.style.display = (display === 'block') ? 'block' : '';
      element.style.visibility = 'visible';
    } else {
      element[elementIndex].style.display = (display === 'block') ? 'block' : '';
      element[elementIndex].style.visibility = 'visible';
    }
  }
}
function hideElement(sel: string, elementIndex: number = 0): void {
  sel = sel.replace('#', '');
  let element: any = document.getElementById(sel);
  if (element) {
    if (element.length === undefined || element.nodeName === 'SELECT') {
      element.style.display = 'none';
      element.style.visibility = 'hidden';
    } else {
      element[elementIndex].style.display = 'none';
      element[elementIndex].style.visibility = 'hidden';
    }
  }
}
function getAjaxObject(): boolean {
  var returnValue: any = false;
  try {
    returnValue = new XMLHttpRequest();
  } catch (trymicrosoft) {
    try {
      returnValue = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (othermicrosoft) {
      try {
        returnValue = new ActiveXObject("Microsoft.XMLHTTP");
      } catch (failed) {
        alert(failed.message);
        returnValue = false;
      }
    }
  }
  return returnValue;
}
function trackError(eventCategory: string, eventAction: string, eventLabel: string, eventParams?: any): void {
  dataLayer.push({
    event: 'trackErrorEvent',
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    event_value: 1
  });
  if (typeof eventParams === 'object') {
    if (eventParams.event === 'placePointsOrderError') {
      dataLayer.push({
        event: eventParams.event,
        detail: {
          email: window.btoa(encodeURIComponent(eventParams.email)),
          bonvoyEmail: window.btoa(encodeURIComponent(eventParams.bonvoyEmail)),
          bonvoyNumber: window.btoa(encodeURIComponent(eventParams.bonvoyNumber)),
          pointsToRedeem: eventParams.pointsToRedeem,
          errorMessage: eventParams.errorMessage
        }
      });
    }
  }
}

function swapPurchaseType (event:any):void {
  event.preventDefault();

  const swapSelectorRequired = () => {

    if ($('#addToCartBtn').attr('type') === 'submit') {
      $('#addToCartBtn').attr('type','button');
      $('#subscribeBtn').attr('type','submit');
    } else {
      $('#addToCartBtn').attr('type','submit');
      $('#subscribeBtn').attr('type','button');
    }

    const isProductSub = document.location.pathname.toLowerCase().includes('productsub');

    if (!isProductSub) return;

    if ($(".addition")[0]) {
      if ($('.item-subscribe.subs').is(":visible")) {
        if (!$('select:eq(1)').attr('required')){
          $('select:eq(1)').attr('required',"true");
        }
        $('select:eq(0)').removeAttr('required');
      } else {
        if (!$('select:eq(0)').attr('required')){
          $('select:eq(0)').attr('required',"true");
        }
        $('select:eq(1)').removeAttr('required');
      }
    } else {
      if ($('.item-subscribe.subs').is(":visible")) {
        if (!$('select:eq(1)').attr('required')){
          $('select:eq(1)').attr('required',"true");
        }
        $('select:eq(0)').removeAttr('required');
      } else {
        if (!$('select:eq(0)').attr('required')){
          $('select:eq(0)').attr('required',"true");
        }
        $('select:eq(1)').removeAttr('required');
      }
    }
  };

  $(this)
    .addClass('opened')
    .attr("tabindex","-1")
    .trigger("focus")
    .attr("aria-expanded","true")
    .removeClass('closed')
    .next('div:hidden')
    .slideDown('fast')
    .siblings('div:visible')
    .slideUp('fast', () => swapSelectorRequired())
    .prev()
    .removeClass('opened')
    .addClass('closed')
    .attr("tabindex", "0")
    .attr("aria-expanded","false");
} 
/**
 * Parses a string of XML data and returns its text content.
 *
 * @param {string} string - The XML string to parse.
 * @returns {string | null} The text content of the XML string, or null if the XML string has no text content.
 */
function parseXMLData(string: string): string | null {
	var parser = new DOMParser()
	var xmlDoc = parser.parseFromString('<root>' + string + '</root>', 'text/xml')
	var decodedContent = xmlDoc.documentElement.textContent
	return decodedContent
}
/**
 * get category values from localStorage for a kit/add-on item that does not belong to a catagory in the DB.
 *
 * @param {basket} string - The XML string to parse.
 * @returns {string} The basketIDcategory obj or an empty string.
 */
function getInvtIDCategory(invtID:string,alternateID:string): {invtID:string,alternateID:string,category:string,categoryID:string}  {
  let invtIDCategory={invtID:'',alternateID:'',category:'',categoryID:''};
  if (localStorage['invtid_category']!==''&&localStorage['invtid_category']!==undefined){
    const invtIDCategoryArray=JSON.parse(localStorage['invtid_category']);
    const found=invtIDCategoryArray.find((elem:{invtID:string,alternateID:string})=>elem.invtID===invtID&&elem.alternateID===alternateID);
    if (found!==undefined) {invtIDCategory=found;}
  }
  return invtIDCategory;
}